<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入专业名称" v-model="specialty_name" @keyup.enter.native="getSpecialty"
        class="input-with-select">
        <el-button slot="append" @click="getSpecialty">
          <img src="@/assets/img/home/search.png" alt="" />
        </el-button>
      </el-input>
    </div>

    <div>
      <div class="specialty-item border-1" @click="search(item)" v-for="(item, key) in SpecialtyList" :key="key">
        <div class="specialty-info">
          {{ item.specialty_name }} <span class="color-1">AI分析</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      SpecialtyList: [],
      userInfo: [],
      specialty_name: null,
      page: {
        pageNum: 1,
        pageSize: 4,
      },
      loading: false
    };
  },
  computed: {
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('UserInfo'))
    this.getSpecialty()
  },
  methods: {
    getSpecialty() {
      if (!this.loading) {
        this.loading = true
        let data = {
          specialty_name: this.specialty_name,
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          is_wenli: this.userInfo.is_wenli,
          score: this.userInfo.score,
        }

        this.$fecth.post('chat/get_specialty_list', data).then((res) => {
          this.loading = false
          this.SpecialtyList = res.lists
        })
      }

    },
    search(e) {
      let data = {
        title: e.specialty_name,
        specialty_name: e.specialty_name,
        type: 3
      }
      this.$emit('getChat', data)
    }
  },
};
</script>

<style scoped lang='less'>
.search {
  margin-bottom: 30px
}

.specialty-item {
  padding: 15px 15px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 20px;
}

.specialty-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
</style>
